var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip-box"},[_c('p',{staticClass:"content"},[_vm._v("提示："+_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }